import { render } from "./HeroiconsSolidCurrencyEuro.vue?vue&type=template&id=26e08cc6"
const script = {}

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCurrencyEuro.vue"]])

export default __exports__